import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ProfileInformation from './Account/ProfileInformation';
import PasswordReset from './Account/PasswordReset';
import AccountActions from './Account/AccountActions';
import NationalIDUpload from './Account/NattionalID';
import DashboardLayout from './DashboardLayout';
import baseURL from '../config';
import { toast } from 'react-toastify';
import PageLoader from '../../../Reusable/PageLoader';

const AccountManagement = () => {
  const [profile, setProfile] = useState(null);
  const [idImages, setIdImages] = useState({ front: null, back: null });
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
       // await new Promise(resolve => setTimeout(resolve, 4000));

      const [profileResponse, idResponse] = await Promise.all([
        fetch(`${baseURL}/user/profile`, { credentials: 'include' }),
        fetch(`${baseURL}/user/national-id`, { credentials: 'include' }),
      ]);

      if (!profileResponse.ok) {
        const errData = await profileResponse.json().catch(() => ({}));
        throw new Error(errData.message || 'Failed to fetch user profile.');
      }

      const profileData = await profileResponse.json();
      setProfile(profileData);

      if (idResponse.ok) {
        const idData = await idResponse.json();
        setIdImages({ front: idData.frontImage, back: idData.backImage });
      } else {
        console.warn('National ID not found, proceeding without it.');
      }
    } catch (err) {
      console.error('Error fetching account data:', err);
      toast.error(err.message || 'Failed to load account data.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDataUpdated = () => {
    fetchData();
  };

  if (loading) {
    return (
      <DashboardLayout>
        <PageLoader />
      </DashboardLayout>
    );
  }

  if (!profile) {
    return (
      <DashboardLayout>
        <Box sx={{ mt: 4 }}>
          <Alert severity="error">Failed to load account data. Please try again.</Alert>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Typography
        variant="h6"
        sx={{
          color: '#666',
          mb: 3,
          textAlign: 'left',
          fontWeight: 600,
          fontSize: { xs: '1.1rem', sm: '1.3rem' },
        }}
      >
        My Account
      </Typography>
      <ProfileInformation profile={profile} onDataUpdated={handleDataUpdated} />
      <NationalIDUpload idImages={idImages} onDataUpdated={handleDataUpdated} />
      <PasswordReset />
      <AccountActions />
    </DashboardLayout>
  );
};

export default AccountManagement;
